import { ReactComponent as Book } from "../../../../assets/icons/book.svg";

const BookIcon = (props) => {
  return <Book fill={props?.active ? "#6fc0ff" : "#A8A8A8"} />;
};

export default BookIcon;
